import { render, staticRenderFns } from "./EquipmentsView.vue?vue&type=template&id=10f5c4a6&scoped=true&"
import script from "./EquipmentsView.vue?vue&type=script&lang=js&"
export * from "./EquipmentsView.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentsView.vue?vue&type=style&index=0&id=10f5c4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5c4a6",
  null
  
)

export default component.exports